import React, { useState } from 'react';
import { isNative } from '../utils/platformUtils';

const PlatformInput = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  error = false,
  size = 'medium',
  className = '',
  ...props
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'input-field';
    const sizeClass = size !== 'medium' ? `size-${size}` : '';
    const errorClass = error ? 'error' : '';
    const disabledClass = disabled ? 'disabled' : '';
    
    return [baseClass, sizeClass, errorClass, disabledClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add platform-specific styles that CANNOT be handled by CSS
    if (isNative()) {
      styles.cursor = 'default'; // Native platforms don't have cursor
    }
    
    return { ...styles, ...props.style };
  };

  // Platform-specific focus handlers
  const handleFocus = (e) => {
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    onBlur?.(e);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        type={type}
        className={getClassName()}
        style={getInlineStyles()}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        {...props}
      />
      {error && (
        <div style={{
          color: 'var(--danger-color)',
          fontSize: '12px',
          marginTop: '4px',
          fontWeight: '500'
        }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PlatformInput; 